import { APIClient } from '@/services'
import { useCallback, useState } from 'react'
import { FilterFeed } from '../Filter/FilterFeed'
import { ActionButton } from './ActionButton'
import { View } from '@/components'
import { Settings } from '@/app'
import { comingSoon } from '@/utils'

export const FilterButton = () => {
  const [showFilters, setShowFilters] = useState(false)

  const handleFilter = useCallback(() => {
    if (!Settings.Community.filtersEnabled) {
      comingSoon()
      return
    }

    const authorized = APIClient.UnknownProfile.maybeOpenRegistrationWall(true, false, 'community-filter')
    if (!authorized) return

    setShowFilters(prev => !prev)
  }, [])

  return (
    <View
      variants={['row', 'gap:1']}
      style={{
        position: 'absolute',
        left: 24,
        top: 24
      }}
    >
      <ActionButton icon="list-filter" onPress={handleFilter} iconStyle={{ width: 24, height: 24 }} />

      <FilterFeed show={showFilters} />
    </View>
  )
}
